import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable } from 'mana-syringe';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { HookHub } from '@antv/xflow-hook';
import { XFlowNodeCommands } from '../constant';
import { Disposable } from '../../common/disposable';
export var NsMoveNode;
(function (NsMoveNode) {
    /** Command: 用于注册named factory */
    NsMoveNode.command = XFlowNodeCommands.MOVE_NODE;
    /** hookName */
    NsMoveNode.hookKey = 'moveNode';
    /** 创建 hook */
    NsMoveNode.createHook = () => {
        return new HookHub();
    };
})(NsMoveNode || (NsMoveNode = {}));
let MoveNodeCommand = 
/** 创建节点命令 */
class MoveNodeCommand {
    constructor() {
        /** 执行Cmd */
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.contextProvider();
            const { args, hooks: runtimeHook } = ctx.getArgs();
            const hooks = ctx.getHooks();
            const result = yield hooks.moveNode.call(args, (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const { nodePositionService } = handlerArgs;
                /** nodePositionService 返回false时不更新position */
                if (nodePositionService) {
                    const canMove = yield nodePositionService(handlerArgs);
                    if (!canMove)
                        return { err: 'service rejected' };
                }
                const { dx = 0, dy = 0, x, y, duration = 150 } = handlerArgs.position;
                const x6Graph = yield ctx.getX6Graph();
                const node = x6Graph.getCellById(handlerArgs.id);
                if (node) {
                    let nextX = x;
                    let nextY = y;
                    const { x: preX, y: preY } = node.position();
                    let undo = () => {
                        node.position(preX, preY, { silent: false });
                    };
                    if (dx || dy) {
                        nextX = dx + preX;
                        nextY = dy + preY;
                        node.translate(dx, dy, { transition: { duration } });
                        undo = () => node.translate(-dx, -dy, { transition: { duration } });
                    }
                    else {
                        node.position(nextX, nextY, { silent: false });
                    }
                    /** add undo  */
                    ctx.addUndo(Disposable.create(() => {
                        undo();
                    }));
                    return { err: null, nextX, nextY };
                }
            }), runtimeHook);
            ctx.setResult(result);
            return this;
        });
        /** undo cmd */
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.contextProvider();
            if (this.isUndoable()) {
                ctx.undo();
            }
            return this;
        });
        /** redo cmd */
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.isUndoable()) {
                yield this.execute();
            }
            return this;
        });
    }
    isUndoable() {
        const ctx = this.contextProvider();
        return ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], MoveNodeCommand.prototype, "contextProvider", void 0);
MoveNodeCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsMoveNode.command.id },
    })
    /** 创建节点命令 */
], MoveNodeCommand);
export { MoveNodeCommand };
//# sourceMappingURL=node-move.js.map